import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAppContext, { actions } from "../../../utils/Reducers";
import { axiosInstance } from "../../../utils/api";
import useFieldValues from "../../../utils/useFieldValues";
import { useAxiosWithAuthorization } from "../../../utils/api";
import loginLogo from "../../../images/DaehanSteel_logo.png";
import loginLogoYk from "../../../images/yksteel_logo.png";

import "../../../styles/mobile/css/mo.css";
import "../../../styles/mobile/css/font-ko.css";

const Login = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const INITIAL_LOGIN_FIELDS = {
    userId: "",
    password: "",
  };
  const [loginFields] = useFieldValues(INITIAL_LOGIN_FIELDS);
  const LOGIN_APP_URL = "/accounts/loginMobile.do";

  const LS_KEY_ID = "LS_KEY_ID";
  const LS_KEY_PW = "LS_KEY_PW";
  const LS_KEY_SAVE_ID_FLAG = "LS_KEY_SAVE_ID_FLAG";

  const [saveIDFlag, setSaveIDFlag] = useState(false);

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: LOGIN_APP_URL,
    },
    { manual: true }
  );

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("Android") > -1) {
      navigate("/mobile/login"); //<-- this doesn't work!!!!
    } else {
      navigate("/login"); //<-- this doesn't work!!!!
    }

    let idFlag = JSON.parse(localStorage.getItem(LS_KEY_SAVE_ID_FLAG));
    //console.log(idFlag);
    if (idFlag !== null) setSaveIDFlag(idFlag);
    if (idFlag === false) {
      localStorage.setItem(LS_KEY_ID, "");
      localStorage.setItem(LS_KEY_PW, "");
    }
    let dataId = localStorage.getItem(LS_KEY_ID);
    let dataPw = localStorage.getItem(LS_KEY_PW);
    //console.log(dataId + " / " + dataPw);
    if (dataId !== null) setUserId(dataId);
    if (dataPw !== null) setPassword(dataPw);
  }, []);

  const handleSaveIDFlag = (event) => {
    if (event.target.checked) {
      localStorage.setItem(LS_KEY_SAVE_ID_FLAG, true);
      setSaveIDFlag(true);
    } else {
      localStorage.setItem(LS_KEY_SAVE_ID_FLAG, false);
      setSaveIDFlag(false);
    }
  };
  const INITIAL_FIELD_RULES = {
    username: {
      rules: [
        {
          max_length: 30,
          message: "최대 30글자까지 입력 가능합니다.",
        },
      ],
    },
    password: {
      rules: [
        {
          max_length: 50,
          message: "최대 50글자까지 입력 가능합니다.",
        },
      ],
    },
  };
  const { dispatch } = useAppContext();
  const submit = async () => {
    loginFields["userId"] = userId;
    loginFields["password"] = password;

    try {
      const response = await axiosInstance.post(LOGIN_APP_URL, loginFields);
      const {
        data: { token, userInfo, code, result },
      } = response;
      //console.log(code);
      //console.log(result);
      if (code === "400") {
        // await ModalConfirm({
        //   title: "로그인 실패",
        //   description: result,
        //   type: "alert",
        // });
        alert(result);
        return;
      } else {
        dispatch(actions.setToken(token));
        dispatch(actions.setUserInfo(userInfo));

        if (true /* login success */) {
          if (saveIDFlag) localStorage.setItem(LS_KEY_ID, userId);
          if (saveIDFlag) localStorage.setItem(LS_KEY_PW, password);
        }

        navigate("/mobile/main", { replace: true });
      }
    } catch (error) {
      if (error.response) {
        const { data: errors } = error.response;
        const _responseErrors = [];
        errors.messages &&
          errors.messages.map(({ message }) => {
            Object.entries(message).map(([key, errorMessage]) => {
              _responseErrors.push(errorMessage);
            });
          });

        for (const _responseError of _responseErrors.reverse()) {
          // eslint-disable-next-line no-restricted-globals
          confirm(_responseError);
          return;
        }
      }
    }

    // const {
    //   data: { data },
    // } = await fetchData({
    //   url: LOGIN_APP_URL,
    //   data: loginFields,
    //   method: "POST",
    // });
    // dispatch(actions.setToken(data.token));
    // dispatch(actions.setUserInfo(data.userInfo.userId));

    // navigate("/", { replace: true });
  };

  const onKeyPress = (event) => {
    if (event.key === "Enter") {
      submit();
    }
  };
  return (
    <form>
      <div className="center">
        <div className="mtitle">
          <div>
            <h3>
              <img src={loginLogo} width="260" alt="LOGO" />
              <img src={loginLogoYk} width="320" alt="yklogo" />
              <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                영상검수시스템
              </span>
            </h3>
          </div>
        </div>
        <ul>
          <li>
            <input
              type="text"
              className="account"
              placeholder="검수원 아이디"
              value={userId}
              onChange={(event) => setUserId(event.target.value)}
            />
          </li>
          <li>
            <input
              type="password"
              className="account"
              placeholder="검수원 비밀번호"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </li>
          <li>
            <button type="button" onClick={submit}>
              LOGIN
            </button>
          </li>
        </ul>
        <div className="chkinfo">
          <div>
            <input
              type="checkbox"
              name="saveEmail"
              id="saveEmail"
              checked={saveIDFlag}
              onChange={handleSaveIDFlag}
            />
            ID/PW 저장
          </div>
        </div>
      </div>
    </form>
  );
};

export default Login;
